
    <!--
 * 竖版-line账号收集
 * @LastEditTime: Mon Dec 23 2024 22:00:18 GMT+0800 (中国标准时间)
 -->
 <template>
  <div id="u_c_KNIA19"  :class="[`normal`,`u_c_KNIA19`]" ><div id="u_c_CRH519"  :style="`background: linear-gradient(to bottom,${ pageData.moduleColorUp },${ pageData.moduleColorDown });`" :class="[`normal`,`u_c_CRH519`]" ><div id="u_c_UYCH20"  :class="[`normal step-title`,`u_c_UYCH20`]" ><div id="u_c_JPBJ29"  :style="`background-color:${ pageData.btnColor };opacity:0.2;`" :class="[`normal`,`u_c_JPBJ29`]" ></div><div id="u_c_62OR22"  :style="`background-color:${ pageData.btnColor }`" :class="[`normal btn-text`,`u_c_62OR22`]" >{{`${ langData.titleStep1 }`}}</div><div id="u_c_TE1V28"  :style="`background-color:${ pageData.btnColor };opacity:0.2;`" :class="[`normal`,`u_c_TE1V28`]" ></div></div><div id="u_c_NTIB21"  :class="[`normal`,`u_c_NTIB21`]" ><div id="u_c_IDPW37"  :style="`background-color:${ pageData.btnColor };opacity:0.2;`" :class="[`normal`,`u_c_IDPW37`]" ></div><div id="u_c_TUNL24"  :class="[`normal`,`u_c_TUNL24`]" ><div id="u_c_TNC023"  :class="[`normal bg-img`,`u_c_TNC023`]" ></div><div id="u_c_KNFT25"  :class="[`normal`,`u_c_KNFT25`]" ><div id="u_c_DGMI26"  :class="[`normal bg-img content`,`u_c_DGMI26`]" >{{`${ compData.lineBotId }`}}</div><div id="u_c_ACMX28"  :class="[`normal`,`u_c_ACMX28`]" ><div id="u_c_DEYD29"  :style="`background-color:${ pageData.btnColor }`" :class="[`normal cursor flex-center`,`u_c_DEYD29`]" @click="u_c_DEYD29_event_EDXM19($event)"><div id="u_c_AHDC21"  :class="[`normal bg-img`,`u_c_AHDC21`]" ></div></div><div id="u_c_EW4P30"  :style="`background-color:${ pageData.btnColor }`" :class="[`normal cursor flex-center`,`u_c_EW4P30`]" @click="u_c_EW4P30_event_7FBE20($event)"><div id="u_c_JKGS19"  :class="[`normal bg-img`,`u_c_JKGS19`]" ></div></div></div></div></div><div id="u_c_QH1531"  :class="[`normal bg-img cursor `,`u_c_QH1531`]" @click="u_c_QH1531_event_M72N21($event)"><div id="u_c_3T7Z38"  v-html="langData.lineAddFriend" :class="[`normal`,`u_c_3T7Z38`]" ></div><div id="u_c_JCWV34"  v-if="pageData.lineAccountName || compData.showEmailCollect" :class="[`normal errtips`,`u_c_JCWV34`]" >{{`${ langData.lineGuanzhu }:${ compData.showEmailCollect ? 'haha' : pageData.lineAccountName }`}}</div></div></div><p id="u_c_HY5620"  v-html="langData.lineSubTitle" :class="[`normal content`,`u_c_HY5620`]" ></p><div id="u_c_YFB630"  :class="[`normal step-title`,`u_c_YFB630`]" ><div id="u_c_O4VI31"  :style="`background-color:${ pageData.btnColor };opacity:0.2;`" :class="[`normal`,`u_c_O4VI31`]" ></div><div id="u_c_WF8K32"  :style="`background-color:${ pageData.btnColor }`" :class="[`normal btn-text`,`u_c_WF8K32`]" >{{`${ langData.titleStep2 }`}}</div><div id="u_c_TWXL34"  :style="`background-color:${ pageData.btnColor };opacity:0.2;`" :class="[`normal`,`u_c_TWXL34`]" ></div></div><div id="u_c_IK7636"  :class="[`normal`,`u_c_IK7636`]" ><div id="u_c_A97A37"  :class="[`normal`,`u_c_A97A37`]" ><swiper id="u_c_Q4FZ38"  :style="`width:${ pageData.isEdit ? compData.awardList.length > 3 ? compData.awardList.length * 25 + '%' : '100%' : '' }`" :modules="modules" :space-between="10" :pagination="({
    el: '.swiper-pagination',
    clickable: true
})" :slides-per-view="compData.awardList.length >= 4 ? 4 : compData.awardList.length" :class="[`normal`,`u_c_Q4FZ38`]" ><template   v-for="(item, index) in compData.awardList" :key="index" :class="[`normal`,`u_c_F5HK39`]" ><swiper-slide id="u_c_XTK286"  :style="`width:${ pageData.isEdit ? compData.awardList.length > 2 ? '33%' : 100 / compData.awardList.length + '%' : '' };justify-content:${ compData.awardList.length > 2 ? 'start' : 'center' }`" :class="[`normal`,`u_c_XTK286`]" ><div id="u_c_PXJ840"  :class="[`normal`,`u_c_PXJ840`]" @click="u_c_PXJ840_event_43ON35($event)"><div id="u_c_T2WB41"  :style="`background: linear-gradient(to bottom,${ pageData.welfareBgColorUp },${ pageData.welfareBgColorDown });`" :class="[`normal award-bg`,`u_c_T2WB41`]" ><div id="u_c_Q4JZ42"  :style="`background-image:url(${ item })`" :class="[`normal`,`u_c_Q4JZ42`]" ></div></div></div></swiper-slide></template></swiper><div id="u_c_YSTA87"  :class="[`normal swiper-pagination`,`u_c_YSTA87`]" ></div></div><div id="u_c_HUTZ46"  v-show="pageData.canModify && pageData.showEmailCollect" :class="[`normal`,`u_c_HUTZ46`]" ><table id="u_c_FTHY47" cellpadding="0" cellspacing="0" :class="[`normal`,`u_c_FTHY47`]" ><tbody id="u_c_ECT748"  :class="[`normal`,`u_c_ECT748`]" ><tr id="u_c_SSLJ49"  :class="[`normal`,`u_c_SSLJ49`]" ><td id="u_c_QSEL50"  :class="[`normal`,`u_c_QSEL50`]" ><div id="u_c_UJES51"  :style="`background-color:#0000004C`" :class="[`normal input input-bg`,`u_c_UJES51`]" ><input id="u_c_GHBN52"  v-model="pageData.lineSerialCode" :disabled="!pageData.canModify" :placeholder="compData.showEmailCollect ? 'haha' : langData.inputCodeTitle" :class="[`normal`,`u_c_GHBN52`]" @focus="u_c_GHBN52_event_46XR20($event)" @change="u_c_GHBN52_event_OTSF18($event)"/></div></td></tr></tbody></table><div id="u_c_BYBR53"  v-if="!compData.showEmailCollect" :style="`background-color:${ pageData.btnColor }`" :class="[({ grey: !pageData.canModify || pageData.lineIsBind }),`normal btn btn-text`,`u_c_BYBR53`]" @click="u_c_BYBR53_event_UJN318($event)">{{`${ langData.exchangeNow }`}}</div><div id="u_c_D3AO29"  v-if="compData.showEmailCollect" :style="`background-color:${ pageData.btnColor }`" :class="[`normal btn grey`,`u_c_D3AO29`]" @click="u_c_D3AO29_event_UJN318($event)">{{`${ langData.exchangeNow }`}}</div><p id="u_c_SF9755"  v-show="compData.showInputCodeTip" :class="[`normal errtips`,`u_c_SF9755`]" ><span id="u_c_IY4U56"  :class="[`normal `,`u_c_IY4U56`]" >{{`${ compData.inputCodeTip }`}}</span></p></div></div><div id="u_c_HNM359"  v-show="compData.showLineSavePopup" :class="[`normal`,`u_c_HNM359`]" ><div id="u_c_N5NV60"  :class="[`normal`,`u_c_N5NV60`]" @click="u_c_N5NV60_event_1SMT51($event)"></div><div id="u_c_THF461"  :class="[`normal bg-img`,`u_c_THF461`]" @click="u_c_THF461_event_GWR933($event)"></div><p id="u_c_OL8K62"  v-html="langData.lineCodeImgSaveTip" v-if="checkIsInSdk() && isIos" :class="[`normal`,`u_c_OL8K62`]" ></p><p id="u_c_IXBK63"  v-html="langData.lineCodeImgSaveTipWeb" v-if="!checkIsInSdk()" :class="[`normal`,`u_c_IXBK63`]" ></p><p id="u_c_P2HZ64"  v-html="langData.lineCodeImgSaveTipScreenshot" v-if="checkIsInSdk() && isAndroid" :class="[`normal`,`u_c_P2HZ64`]" ></p></div><div id="u_c_CZLO65"  v-show="compData.showLineCopyTipPopup" :class="[`normal`,`u_c_CZLO65`]" ><div id="u_c_HRX266"  :class="[`normal`,`u_c_HRX266`]" @click="u_c_HRX266_event_1SMT51($event)"></div><p id="u_c_GZKX67"  v-html="langData.lineCopySuccTip" :class="[`normal`,`u_c_GZKX67`]" ></p></div></div></div>
  </template>
<script setup>
import {reactive,provide,inject,onMounted,watch,watchEffect,ref,computed,nextTick,readonly,toRaw,markRaw} from "vue";
import * as vueUse from "@vueuse/core";
import Language from "@/hooks/language.js";
import Router from "@/hooks/router.js";
import bridge from "@/utils/sdkBridge.js";
import { useRoute } from 'vue-router';
import * as request from "@/api/request";
import * as utils from "@/utils";
import * as _ from "lodash-es";
import useClipboard from "vue-clipboard3";import { Swiper, SwiperSlide } from "swiper/vue";import { Pagination } from "swiper";import "swiper/css";  import 'swiper/css/pagination';

    const { curLang, getLangTxt,langData } = Language();
    const routerData = inject("routerData",{});
    const pageData = inject("pageData", {});
    const COMP_DATA_LANG = {"default":{"getCode":"获取验证码","getCodeCanClick":true,"showEmailCollect":false,"awardList":["https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/08/1724228236704-52.png","https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/08/1724228236581-5.png","https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/08/1724228236598-93.png","https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/08/1724228236599-15.png","https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/08/1724228236605-32.png","https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/08/1724228236607-24.png","https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/08/1724228236595-9.png"],"awardName":`奖励名`,"emailPageTitle":``,"mainTitleBg":``,"showLineSavePopup":false,"showLineCopyTipPopup":false,"showInputCodeTip":false,"inputCodeTip":``,"lineBotId":`@37games_pns`,"welfareList":[{
  label:'welfareName1',
  icon:'',
  key:'1',
},{
  label:'welfareName2',
  icon:'',
  key:'1',
},{
  label:'welfareName3', 
  icon:'',
  key:'1',
}]},"ja-JP":{"getCode":"获取验证码","getCodeCanClick":true,"showEmailCollect":false,"awardList":["https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/08/1724228236704-52.png","https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/08/1724228236581-5.png","https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/08/1724228236598-93.png","https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/08/1724228236599-15.png","https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/08/1724228236605-32.png","https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/08/1724228236607-24.png","https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/08/1724228236595-9.png"],"awardName":`ダイヤ*300,研究ブースト（5分間）*10,訓練ブースト（5分間）*10,ブースト（5分間）*10,血清×1,000*3,R3マニュアル*5,選択型強化補給*1`,"emailPageTitle":``,"mainTitleBg":``,"showLineSavePopup":false,"showLineCopyTipPopup":false,"showInputCodeTip":false,"inputCodeTip":``,"lineBotId":`@37games_pns`,"welfareList":[{
  label:'welfareName1',
  icon:'',
  key:'1',
},{
  label:'welfareName2',
  icon:'',
  key:'1',
},{
  label:'welfareName3', 
  icon:'',
  key:'1',
}]}};
    const compData = reactive(COMP_DATA_LANG[curLang] || COMP_DATA_LANG['ja-JP']||{});
    let pagePlatform = "global"
    const router = Router();
    const route = useRoute();
    const compName = 'line账号收集';

    // 自定义setup - 开始
    const {
  toClipboard
} = useClipboard();
compData.getCode = langData.sendCode;
// 验证码限时120
const CODE_SEND_WAIT = 120;
// 验证码发送计时器
let timer = null;
let timerTime = CODE_SEND_WAIT;

const clickCheckIsLogin = inject("clickCheckIsLogin", () => {});
const clickCheckIsBind = inject("clickCheckIsBind", () => {});
const initActivityInfo = inject("initActivityInfo", () => {});
const getDiscordAward = inject("getDiscordAward", () => {});

const canGetAward = ref(true);

// 是否可检测，默认一开始不能检测，当第一次聚焦的时候，开始实时检测
const emailCanCheck = ref(false);
const codeCanCheck = ref(false);

// 截流点击限制
const submitBtnCanClick = ref(true);

// 实时检测邮箱格式
const judgeEmail = computed(() => {
  return emailCanCheck.value ?
    /^([a-zA-Z0-9_-])+([a-zA-Z0-9_.-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(
      pageData.email
    ) :
    true;
});

//  实时检测验证码是否有填
const judgeCode = computed(() => {
  return codeCanCheck.value ? pageData.code : true;
});

// 倒计时实现
const excTimer = async () => {
  return new Promise((resolve) => {
    if (timer) {
      clearInterval(timer);
      timer = null;
    }
    timerTime = CODE_SEND_WAIT;
    compData.getCode = `${langData.hasSend1}(${timerTime}s)`;
    timer = setInterval(() => {
      if (timerTime > 0) {
        timerTime--;
        compData.getCode = `${langData.hasSend1}(${timerTime}s)`;
      } else {
        compData.getCode = langData.sendCode;
        compData.getCodeCanClick = true;
        clearInterval(timer);
        resolve();
      }
    }, 1000);
  });
};

// 获取验证码接口
const excGetCode = async () => {
  let res = await request.getJSON(
    utils.getActivityApi(pagePlatform, pageData.pageId, 'email_code'), {
      params: JSON.stringify({
        email: encodeURIComponent(pageData.email),
        language: curLang
      })
    }
  );
  if (res.result != 1) {
    compData.inputCodeTip = getLangTxt(res.code, res.msg);
    compData.showInputCodeTip = true
    // pageData.commonTipState = true;
    // pageData.commonTipsContent = getLangTxt(res.code, res.msg);
  }
  return res.result == 1;
};

// 提交接口
const excSubmitEmail = async () => {
  let res = await request.getJSON(
    utils.getActivityApi(pagePlatform, pageData.pageId, 'exchangeSerial'), {
      params: JSON.stringify({
        role_id: pageData.roleId,
        role_name: encodeURIComponent(pageData.roleName),
        server_sid: pageData.sid,
        server_name: encodeURIComponent(pageData.serverName),
        cid: utils.getUrlParams('cid'),
        scid: utils.getUrlParams('scid'),
        serial_code: pageData.lineSerialCode
      })
    }
  );
  if (res.result != 1) {
    compData.inputCodeTip = getLangTxt(res.code, res.msg);
    compData.showInputCodeTip = true
    // pageData.commonTipState = true;
    // pageData.commonTipsContent = getLangTxt(res.code, res.msg);
  }
  return res.result == 1;
};

const canPointEmail = ref(true);
const canPointCode = ref(true);

const isAndroid = utils.getUrlParams('devicePlate') === 'android'
const isIos = utils.getUrlParams('devicePlate') === 'ios'
const checkIsInSdk = () => {
  return bridge.runInsdk()
}
const saveImage = () => {
  const saveA = document.createElement('a')
  saveA.href = 'https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/03/1711704237187-26.png'
  saveA.download = 'lineQrCode' + new Date().getTime()
  saveA.target = '_self'
  saveA.click()
}
const init = () => {
  compData.showEmailCollect = false
  if (!pageData.isLogin) {
    initActivityInfo();
  }
};
init();;
      // 复制按钮的click事件
      const u_c_DEYD29_event_EDXM19= async (e)=>{
        try {await toClipboard(compData.lineBotId);

window.activityDataLayer.push({
  eventName: 'click_button',
  eventType: '复制按钮',
  gameId: pageData.gameId,
  aid: pageData.pageId,
});

compData.showLineCopyTipPopup = true

setTimeout(()=>{
  compData.showLineCopyTipPopup = false
},2000)} catch (error) {console.log(error)}
      };
      // 二维码按钮的click事件
      const u_c_EW4P30_event_7FBE20= async (e)=>{
        try {compData.showLineSavePopup = true

window.activityDataLayer.push({
  eventName: 'click_button',
  eventType: '获取二维码按钮',
  gameId: pageData.gameId,
  aid: pageData.pageId,
});
} catch (error) {console.log(error)}
      };
      // 关注按钮的click事件
      const u_c_QH1531_event_M72N21= async (e)=>{
        try {          if (bridge.runInsdk()) {
            bridge.callSdkMethod("openBrowser", {
              url: pageData.lineDeepLink,
              loginDir: 0,
              appendParams: 0,
            });
          } else {
            window.open(pageData.lineDeepLink, "_blank");
          }} catch (error) {console.log(error)}
      };
      // 奖励项主体的click事件
      const u_c_PXJ840_event_43ON35= async (e)=>{
        try {pageData.awardPopupContent = compData.awardName;
pageData.awardPopupState = true;} catch (error) {console.log(error)}
      };
      // 兑换码输入框的focus事件
      const u_c_GHBN52_event_46XR20= async (e)=>{
        try {if (pageData.lineIsBind) return
if (!clickCheckIsLogin()) return;
if (!clickCheckIsBind()) return;
emailCanCheck.value = true;
} catch (error) {console.log(error)}
      };
      // 兑换码输入框的change事件
      const u_c_GHBN52_event_OTSF18= async (e)=>{
        try {if(!canPointEmail.value)return
try {
  window.activityDataLayer.push({
    eventName: "input_email",
    eventType: "输入兑换码",
    gameId: pageData.gameId,
    aid: pageData.pageId,
  })
  canPointEmail.value = false;
} catch (error) {}} catch (error) {console.log(error)}
      };
      // 提交按钮的click事件
      const u_c_BYBR53_event_UJN318= async (e)=>{
        try {if (pageData.lineIsBind) return
if (!pageData.canModify) return
if (!clickCheckIsLogin()) return
if (!clickCheckIsBind()) return

// emailCanCheck.value = true;
// codeCanCheck.value = true;

// if (!judgeEmail.value) return;
// if (!judgeCode.value) return;
if (!pageData.lineSerialCode) {
  compData.inputCodeTip = langData.inputCodeTitle
  compData.showInputCodeTip = true
  return;
} else {
  compData.showInputCodeTip = false
}
if (!submitBtnCanClick.value) return
try {
  window.activityDataLayer.push({
    eventName: "click_button",
    eventType: "提交line兑换码按钮",
    gameId: pageData.gameId,
    aid: pageData.pageId,
  })
  window.dataLayer.push({
    event: "uploadPoint",
    eventName: "点击提交line兑换码按钮",
    aid: pageData.pageId,
  })
} catch (error) {}
submitBtnCanClick.value = false
let res = await excSubmitEmail()
submitBtnCanClick.value = true

if (res) {
  // pageData.bindSuccState = true
  pageData.canModify = false
  compData.showInputCodeTip = false;
  initActivityInfo()
  try {
    window.dataLayer.push({
      event: "creatEvt",
      manualEvent: "提交成功",
    })
  } catch (error) {}
}} catch (error) {console.log(error)}
      };
      // 提交按钮已绑定的click事件
      const u_c_D3AO29_event_UJN318= async (e)=>{
        try {if (pageData.lineIsBind) return
if (!pageData.canModify) return
if (!clickCheckIsLogin()) return
if (!clickCheckIsBind()) return

// emailCanCheck.value = true;
// codeCanCheck.value = true;

// if (!judgeEmail.value) return;
// if (!judgeCode.value) return;
if (!pageData.lineSerialCode) {
  compData.inputCodeTip = langData.inputCodeTitle
  compData.showInputCodeTip = true
  return;
} else {
  compData.showInputCodeTip = false
}
if (!submitBtnCanClick.value) return
try {
  window.activityDataLayer.push({
    eventName: "click_button",
    eventType: "提交line兑换码按钮",
    gameId: pageData.gameId,
    aid: pageData.pageId,
  })
  window.dataLayer.push({
    event: "uploadPoint",
    eventName: "点击提交line兑换码按钮",
    aid: pageData.pageId,
  })
} catch (error) {}
submitBtnCanClick.value = false
let res = await excSubmitEmail()
submitBtnCanClick.value = true

if (res) {
  // pageData.bindSuccState = true
  pageData.canModify = false
  compData.showInputCodeTip = false;
  initActivityInfo()
  try {
    window.dataLayer.push({
      event: "creatEvt",
      manualEvent: "提交成功",
    })
  } catch (error) {}
}} catch (error) {console.log(error)}
      };
      // 萌层的click事件
      const u_c_N5NV60_event_1SMT51= async (e)=>{
        try {compData.showLineSavePopup = false} catch (error) {console.log(error)}
      };
      // 二维码的click事件
      const u_c_THF461_event_GWR933= async (e)=>{
        try {if(!checkIsInSdk()) {
  saveImage()
}} catch (error) {console.log(error)}
      };
      // 萌层的click事件
      const u_c_HRX266_event_1SMT51= async (e)=>{
        try {compData.showLineCopyTipPopup = false} catch (error) {console.log(error)}
      };const modules = computed(()=> [Pagination])
    // 自定义setup - 结束


</script>
<style lang="scss" scoped>
.default{
.u_c_KNIA19.normal{
position:relative;
display:flex;
justify-content:center;
width:10.00rem;
align-items:center;
flex-direction:column;
margin-top:7.72rem;

}

.u_c_KNIA19.normal .title-text{
font-size:0.39rem;
color:#fff1ce;
line-height:120%;

}

.u_c_KNIA19.normal .email-item{
display:flex;
justify-content:flex-start;
align-items:center;
margin-bottom:0.53rem;

}

.u_c_KNIA19.normal .grey{
filter:grayscale(1);
cursor:auto;

}

.u_c_KNIA19.normal .grey:hover{
cursor:auto;

}

.u_c_KNIA19.normal .input input{
font-size:0.32rem;
padding:0 0.29rem;
box-sizing:border-box;

}

.u_c_KNIA19.normal .errtips{
font-size:0.29rem;
color:#F8F0D9;
margin:0;
bottom:-0.48rem;
width:100%;
text-align:center;

}

.u_c_KNIA19.normal .opacity{
opacity:0;

}

.u_c_KNIA19.normal .btn{
background-size:contain;
background-repeat:no-repeat;
background-position:center;
cursor:pointer;
font-size:0.53rem;
display:flex;
font-weight:blod;
justify-content:center;
align-items:center;
border-radius:0.12rem;

}

.u_c_KNIA19.normal .input input,.normal input::-webkit-input-placeholder{
color:#ffffff;

}

.u_c_KNIA19.normal .input-bg{
width:8.67rem;
height:1.07rem;
background-repeat:no-repeat;
background-position:center;
background-size:contain;

}

.u_c_KNIA19.normal .bg-img{
background-size:contain;
background-repeat:no-repeat;

}

.u_c_KNIA19.normal .cursor{
cursor:pointer;

}

.u_c_KNIA19.normal .flex-center{
display:flex;
justify-content:center;
align-items:center;

}
input{background:none;border:none;outline:none}

input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
  -webkit-transition-delay: 111111s;
  -webkit-transition: color 11111s ease-out, background-color 111111s ease-out;
}}.default{
.u_c_CRH519.normal{
position:relative;
width:9.20rem;
height:fit-content;
background:#ffecc9;
margin-bottom:0.36rem;
border-radius:0.21rem;
padding:0.53rem 0.27rem;
box-sizing:border-box;
text-align:center;

}
}.default{
.u_c_UYCH20.normal{
position:relative;
width:100%;
display:flex;
justify-content:center;
align-items:center;
box-sizing:border-box;
padding:0 1.07rem;

}
}.default{
.u_c_JPBJ29.normal{
position:relative;
height:0.01rem;
background:#000;
width:1.92rem;

}
}.default{
.u_c_62OR22.normal{
font-size:0.32rem;
color:#ffffff;
font-weight:bold;
line-height:0.48rem;
text-transform:uppercase;
padding:0.13rem 0.67rem;
border-radius:0.39rem;
width:fit-content;
margin:0 0.29rem;

}
}.default{
.u_c_TE1V28.normal{
position:relative;
height:0.01rem;
background:#000;
width:1.92rem;

}
}.default{
.u_c_NTIB21.normal{
position:relative;
display:flex;
justify-content:space-between;
width:auto;
margin-top:0.59rem;

}
}.default{
.u_c_IDPW37.normal{
position:absolute;
width:100%;
height:100%;
z-index:0;
border-radius:9px;

}
}.default{
.u_c_TUNL24.normal{
display:flex;
z-index:1;
box-sizing:border-box;
padding:0.27rem;
justify-content:space-between;
width:5.91rem;

}
}.default{
.u_c_TNC023.normal{
height:1.48rem !important;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1734504869399-88.jpeg);
width:1.48rem !important;
margin-right:0.24rem;

}
}.default{
.u_c_KNFT25.normal{
display:flex;
justify-content:space-between;
flex-direction:column;

}
}.default{
.u_c_DGMI26.normal{
width:3.33rem;
height:0.27rem;
font-size:0.29rem;
color:#333333;
display:flex;
align-items:center;
padding-left:0;
box-sizing:border-box;
margin-right:0.27rem;
margin-bottom:0.25rem;

}
}.default{
.u_c_ACMX28.normal{
display:flex;

}
}.default{
.u_c_DEYD29.normal{
width:1.52rem;
height:0.88rem;
margin-right:0.27rem;
background-color:#cb7e11;
border-radius:0.08rem;

}
}.default{
.u_c_AHDC21.normal{
position:relative;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/08/1723610377888-66.png);
width:0.59rem;
height:0.59rem;

}
}.default{
.u_c_EW4P30.normal{
width:1.52rem;
height:0.88rem;
border-radius:0.08rem;

}
}.default{
.u_c_JKGS19.normal{
position:relative;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/08/1723610377880-53.png);
width:0.59rem;
height:0.59rem;

}
}.default{
.u_c_QH1531.normal{
width:2.75rem;
height:2.03rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/08/1723541276074-57.png);
font-size:0.43rem;
color:#ffffff;
display:flex;
justify-content:center;
align-items:center;
flex-direction:column;
z-index:1;

}
}.default{
.u_c_3T7Z38.normal{
width:auto;
color:#ffffff;
font-weight:normal;
white-space:pre-wrap;
line-height:0.49rem;
margin-right:0.55rem;

}
}.default{
.u_c_JCWV34.normal{
position:absolute;
width:inherit !important;
display:flex;
justify-content:end;
white-space:nowrap;
top:-0.47rem;

}
}.default{
.u_c_HY5620.normal{
position:relative;
display:block;
font-size:0.31rem;
z-index:2;
color:#333333;
text-align:center;
margin-bottom:0.51rem;
white-space:pre-wrap;
margin-top:0.40rem;

}
}.default{
.u_c_YFB630.normal{
position:relative;
width:100%;
display:flex;
justify-content:center;
align-items:center;
box-sizing:border-box;
padding:0 1.07rem;

}
}.default{
.u_c_O4VI31.normal{
position:relative;
height:0.01rem;
background:#000;
width:1.92rem;

}
}.default{
.u_c_WF8K32.normal{
font-size:0.32rem;
color:#ffffff;
font-weight:bold;
line-height:0.48rem;
text-transform:uppercase;
padding:0.13rem 0.67rem;
border-radius:0.39rem;
width:fit-content;
margin:0 0.29rem;

}
}.default{
.u_c_TWXL34.normal{
position:relative;
height:0.01rem;
background:#000;
width:1.92rem;

}
}.default{
.u_c_IK7636.normal{
position:relative;
display:flex;
height:fit-content;
flex-direction:column;
align-items:center;

}
}.default{
.u_c_A97A37.normal{
margin-top:0.41rem;
margin-bottom:0.27rem;
width:100%;
overflow:hidden;
position:relative;
height:1.95rem;

}
}.default{
.u_c_Q4FZ38.normal{
position:relative;
width:100%;
margin:auto;
display:flex;
white-space:nowrap;
overflow-y:hidden;
gap:0.16rem;
flex-wrap:nowrap;
align-items:center;
padding-bottom:0.13rem;
justify-content:start;
z-index:7;

}
}.default{
.u_c_XTK286.normal{
position:relative;
display:flex;

}
}.default{
.u_c_PXJ840.normal{
position:relative;

}
}.default{
.u_c_T2WB41.normal{
position:relative;
width:1.84rem;
height:1.84rem;
background-repeat:no-repeat;
background-size:contain;
display:flex;
justify-content:center;
align-items:center;
margin-bottom:0.05rem;
border-radius:0.12rem;

}
}.default{
.u_c_Q4JZ42.normal{
position:relative;
width:70%;
height:70%;
background-repeat:no-repeat;
background-size:contain;
background-position:center;

}
}.default{
.u_c_YSTA87.normal{
position:absolute;
bottom:0;
z-index:6;

}

.u_c_YSTA87 :deep(.swiper-pagination-bullet){
background:#cb7e11;
height:0.21rem;
width:0.21rem;
margin-top:0.27rem;

}
}.default{
.u_c_HUTZ46.normal{
position:relative;

}
}.default{
.u_c_FTHY47.normal{
position:relative;

}
}.default{
.u_c_ECT748.normal{
position:relative;

}
}.default{
.u_c_SSLJ49.normal{
position:relative;
display:block;
font-size:0;

}
}.default{
.u_c_QSEL50.normal{
position:relative;

}
}.default{
.u_c_UJES51.normal{
position:relative;
border-radius:0.12rem;

}
}.default{
.u_c_GHBN52.normal{
position:relative;
width:100%;
height:100%;

}
}.default{
.u_c_BYBR53.normal{
position:relative;
background-size:contain;
background-repeat:no-repeat;
background-position:center;
cursor:pointer;
font-size:0.43rem;
display:flex;
justify-content:center;
align-items:center;
margin-top:0.21rem;
width:100%;
height:1.07rem;
margin-left:0 !important;
margin-right:0 !important;

}

.u_c_BYBR53.normal:hover{
cursor:pointer;

}
}.default{
.u_c_D3AO29.normal{
position:relative;
background-size:contain;
background-repeat:no-repeat;
background-position:center;
cursor:pointer;
font-size:0.53rem;
display:flex;
justify-content:center;
align-items:center;
margin-top:0.20rem;
width:100%;
height:1.07rem;
margin-left:0 !important;
margin-right:0 !important;

}

.u_c_D3AO29.normal:hover{
cursor:pointer;

}
}.default{
.u_c_SF9755.normal{
position:relative;

}
}.default{
.u_c_IY4U56.normal{
position:relative;

}
}.default{
.u_c_HNM359.normal{
position:fixed;
width:100%;
height:100%;
display:flex;
flex-direction:column;
align-items:center;
justify-content:center;
z-index:10;
left:0;
top:0;

}
}.default{
.u_c_N5NV60.normal{
position:absolute;
width:100%;
height:100%;
top:0;
left:0;
background-color:rgba(0,0,0,.6);

}
}.default{
.u_c_THF461.normal{
position:relative;
width:6.40rem !important;
height:6.40rem !important;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/03/1711704237187-26.png);

}
}.default{
.u_c_OL8K62.normal{
font-size:0.33rem;
color:#ffffff;
margin-top:0.40rem;
line-height:0.40rem;
width:80%;
text-align:center;
position:relative;

}
}.default{
.u_c_IXBK63.normal{
font-size:0.33rem;
color:#ffffff;
margin-top:0.40rem;
line-height:0.40rem;
width:80%;
text-align:center;
position:relative;

}
}.default{
.u_c_P2HZ64.normal{
font-size:0.33rem;
color:#ffffff;
margin-top:0.40rem;
line-height:0.40rem;
width:80%;
text-align:center;
position:relative;

}
}.default{
.u_c_CZLO65.normal{
position:fixed;
width:100%;
height:100%;
display:flex;
flex-direction:column;
align-items:center;
justify-content:center;
z-index:10;
left:0;
top:0;

}
}.default{
.u_c_HRX266.normal{
position:absolute;
width:100%;
height:100%;
top:0;
left:0;
background-color:rgba(0,0,0,.6);

}
}.default{
.u_c_GZKX67.normal{
font-size:0.33rem;
color:#ffffff;
margin-top:0.40rem;
line-height:0.40rem;
text-align:center;
position:relative;
background-color:#40403f;
border-radius:0.13rem;
padding-top:0.20rem;
padding-bottom:0.20rem;
padding-right:0.33rem;
padding-left:0.33rem;

}
}.ja-JP{
.u_c_KNIA19.normal{
position:relative;
display:flex;
justify-content:center;
width:10.00rem;
align-items:center;
flex-direction:column;
margin-top:7.72rem;

}

.u_c_KNIA19.normal .title-text{
font-size:0.39rem;
color:#fff1ce;
line-height:120%;

}

.u_c_KNIA19.normal .email-item{
display:flex;
justify-content:flex-start;
align-items:center;
margin-bottom:0.53rem;

}

.u_c_KNIA19.normal .grey{
filter:grayscale(1);
cursor:auto;

}

.u_c_KNIA19.normal .grey:hover{
cursor:auto;

}

.u_c_KNIA19.normal .input input{
font-size:0.32rem;
padding:0 0.29rem;
box-sizing:border-box;

}

.u_c_KNIA19.normal .errtips{
font-size:0.29rem;
color:#F8F0D9;
margin:0;
bottom:-0.48rem;
width:100%;
text-align:center;

}

.u_c_KNIA19.normal .opacity{
opacity:0;

}

.u_c_KNIA19.normal .btn{
background-size:contain;
background-repeat:no-repeat;
background-position:center;
cursor:pointer;
font-size:0.53rem;
display:flex;
font-weight:blod;
justify-content:center;
align-items:center;
border-radius:0.12rem;

}

.u_c_KNIA19.normal .input input,.normal input::-webkit-input-placeholder{
color:#ffffff;

}

.u_c_KNIA19.normal .input-bg{
width:8.67rem;
height:1.07rem;
background-repeat:no-repeat;
background-position:center;
background-size:contain;

}

.u_c_KNIA19.normal .bg-img{
background-size:contain;
background-repeat:no-repeat;

}

.u_c_KNIA19.normal .cursor{
cursor:pointer;

}

.u_c_KNIA19.normal .flex-center{
display:flex;
justify-content:center;
align-items:center;

}
input{background:none;border:none;outline:none}

input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
  -webkit-transition-delay: 111111s;
  -webkit-transition: color 11111s ease-out, background-color 111111s ease-out;
}}.ja-JP{
.u_c_CRH519.normal{
position:relative;
width:9.20rem;
height:fit-content;
background:#ffecc9;
margin-bottom:0.36rem;
border-radius:0.21rem;
padding:0.53rem 0.27rem;
box-sizing:border-box;
text-align:center;

}
}.ja-JP{
.u_c_UYCH20.normal{
position:relative;
width:100%;
display:flex;
justify-content:center;
align-items:center;
box-sizing:border-box;
padding:0 1.07rem;

}
}.ja-JP{
.u_c_JPBJ29.normal{
position:relative;
height:0.01rem;
background:#000;
width:1.92rem;

}
}.ja-JP{
.u_c_62OR22.normal{
font-size:0.32rem;
color:#ffffff;
font-weight:bold;
line-height:0.48rem;
text-transform:uppercase;
padding:0.13rem 0.67rem;
border-radius:0.39rem;
width:fit-content;
margin:0 0.29rem;

}
}.ja-JP{
.u_c_TE1V28.normal{
position:relative;
height:0.01rem;
background:#000;
width:1.92rem;

}
}.ja-JP{
.u_c_NTIB21.normal{
position:relative;
display:flex;
justify-content:space-between;
width:auto;
margin-top:0.59rem;

}
}.ja-JP{
.u_c_IDPW37.normal{
position:absolute;
width:100%;
height:100%;
z-index:0;
border-radius:9px;

}
}.ja-JP{
.u_c_TUNL24.normal{
display:flex;
z-index:1;
box-sizing:border-box;
padding:0.27rem;
justify-content:space-between;
width:5.91rem;

}
}.ja-JP{
.u_c_TNC023.normal{
height:1.48rem !important;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1734504869399-88.jpeg);
width:1.48rem !important;
margin-right:0.24rem;

}
}.ja-JP{
.u_c_KNFT25.normal{
display:flex;
justify-content:space-between;
flex-direction:column;

}
}.ja-JP{
.u_c_DGMI26.normal{
width:3.33rem;
height:0.27rem;
font-size:0.29rem;
color:#333333;
display:flex;
align-items:center;
padding-left:0;
box-sizing:border-box;
margin-right:0.27rem;
margin-bottom:0.25rem;

}
}.ja-JP{
.u_c_ACMX28.normal{
display:flex;

}
}.ja-JP{
.u_c_DEYD29.normal{
width:1.52rem;
height:0.88rem;
margin-right:0.27rem;
background-color:#cb7e11;
border-radius:0.08rem;

}
}.ja-JP{
.u_c_AHDC21.normal{
position:relative;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/08/1723610377888-66.png);
width:0.59rem;
height:0.59rem;

}
}.ja-JP{
.u_c_EW4P30.normal{
width:1.52rem;
height:0.88rem;
border-radius:0.08rem;

}
}.ja-JP{
.u_c_JKGS19.normal{
position:relative;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/08/1723610377880-53.png);
width:0.59rem;
height:0.59rem;

}
}.ja-JP{
.u_c_QH1531.normal{
width:2.75rem;
height:2.03rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/08/1723541276074-57.png);
font-size:0.43rem;
color:#ffffff;
display:flex;
justify-content:center;
align-items:center;
flex-direction:column;
z-index:1;

}
}.ja-JP{
.u_c_3T7Z38.normal{
width:auto;
color:#ffffff;
font-weight:normal;
white-space:pre-wrap;
line-height:0.49rem;
margin-right:0.55rem;

}
}.ja-JP{
.u_c_JCWV34.normal{
position:absolute;
width:inherit !important;
display:flex;
justify-content:end;
white-space:nowrap;
top:-0.47rem;

}
}.ja-JP{
.u_c_HY5620.normal{
position:relative;
display:block;
font-size:0.31rem;
z-index:2;
color:#333333;
text-align:center;
margin-bottom:0.51rem;
white-space:pre-wrap;
margin-top:0.40rem;

}
}.ja-JP{
.u_c_YFB630.normal{
position:relative;
width:100%;
display:flex;
justify-content:center;
align-items:center;
box-sizing:border-box;
padding:0 1.07rem;

}
}.ja-JP{
.u_c_O4VI31.normal{
position:relative;
height:0.01rem;
background:#000;
width:1.92rem;

}
}.ja-JP{
.u_c_WF8K32.normal{
font-size:0.32rem;
color:#ffffff;
font-weight:bold;
line-height:0.48rem;
text-transform:uppercase;
padding:0.13rem 0.67rem;
border-radius:0.39rem;
width:fit-content;
margin:0 0.29rem;

}
}.ja-JP{
.u_c_TWXL34.normal{
position:relative;
height:0.01rem;
background:#000;
width:1.92rem;

}
}.ja-JP{
.u_c_IK7636.normal{
position:relative;
display:flex;
height:fit-content;
flex-direction:column;
align-items:center;

}
}.ja-JP{
.u_c_A97A37.normal{
margin-top:0.41rem;
margin-bottom:0.27rem;
width:100%;
overflow:hidden;
position:relative;
height:1.95rem;

}
}.ja-JP{
.u_c_Q4FZ38.normal{
position:relative;
width:100%;
margin:auto;
display:flex;
white-space:nowrap;
overflow-y:hidden;
gap:0.16rem;
flex-wrap:nowrap;
align-items:center;
padding-bottom:0.13rem;
justify-content:start;
z-index:7;

}
}.ja-JP{
.u_c_XTK286.normal{
position:relative;
display:flex;

}
}.ja-JP{
.u_c_PXJ840.normal{
position:relative;

}
}.ja-JP{
.u_c_T2WB41.normal{
position:relative;
width:1.84rem;
height:1.84rem;
background-repeat:no-repeat;
background-size:contain;
display:flex;
justify-content:center;
align-items:center;
margin-bottom:0.05rem;
border-radius:0.12rem;

}
}.ja-JP{
.u_c_Q4JZ42.normal{
position:relative;
width:70%;
height:70%;
background-repeat:no-repeat;
background-size:contain;
background-position:center;

}
}.ja-JP{
.u_c_YSTA87.normal{
position:absolute;
bottom:0;
z-index:6;

}

.u_c_YSTA87 :deep(.swiper-pagination-bullet){
background:#cb7e11;
height:0.21rem;
width:0.21rem;
margin-top:0.27rem;

}
}.ja-JP{
.u_c_HUTZ46.normal{
position:relative;

}
}.ja-JP{
.u_c_FTHY47.normal{
position:relative;

}
}.ja-JP{
.u_c_ECT748.normal{
position:relative;

}
}.ja-JP{
.u_c_SSLJ49.normal{
position:relative;
display:block;
font-size:0;

}
}.ja-JP{
.u_c_QSEL50.normal{
position:relative;

}
}.ja-JP{
.u_c_UJES51.normal{
position:relative;
border-radius:0.12rem;

}
}.ja-JP{
.u_c_GHBN52.normal{
position:relative;
width:100%;
height:100%;

}
}.ja-JP{
.u_c_BYBR53.normal{
position:relative;
background-size:contain;
background-repeat:no-repeat;
background-position:center;
cursor:pointer;
font-size:0.43rem;
display:flex;
justify-content:center;
align-items:center;
margin-top:0.21rem;
width:100%;
height:1.07rem;
margin-left:0 !important;
margin-right:0 !important;

}

.u_c_BYBR53.normal:hover{
cursor:pointer;

}
}.ja-JP{
.u_c_D3AO29.normal{
position:relative;
background-size:contain;
background-repeat:no-repeat;
background-position:center;
cursor:pointer;
font-size:0.53rem;
display:flex;
justify-content:center;
align-items:center;
margin-top:0.20rem;
width:100%;
height:1.07rem;
margin-left:0 !important;
margin-right:0 !important;

}

.u_c_D3AO29.normal:hover{
cursor:pointer;

}
}.ja-JP{
.u_c_SF9755.normal{
position:relative;

}
}.ja-JP{
.u_c_IY4U56.normal{
position:relative;

}
}.ja-JP{
.u_c_HNM359.normal{
position:fixed;
width:100%;
height:100%;
display:flex;
flex-direction:column;
align-items:center;
justify-content:center;
z-index:10;
left:0;
top:0;

}
}.ja-JP{
.u_c_N5NV60.normal{
position:absolute;
width:100%;
height:100%;
top:0;
left:0;
background-color:rgba(0,0,0,.6);

}
}.ja-JP{
.u_c_THF461.normal{
position:relative;
width:6.40rem !important;
height:6.40rem !important;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/03/1711704237187-26.png);

}
}.ja-JP{
.u_c_OL8K62.normal{
font-size:0.33rem;
color:#ffffff;
margin-top:0.40rem;
line-height:0.40rem;
width:80%;
text-align:center;
position:relative;

}
}.ja-JP{
.u_c_IXBK63.normal{
font-size:0.33rem;
color:#ffffff;
margin-top:0.40rem;
line-height:0.40rem;
width:80%;
text-align:center;
position:relative;

}
}.ja-JP{
.u_c_P2HZ64.normal{
font-size:0.33rem;
color:#ffffff;
margin-top:0.40rem;
line-height:0.40rem;
width:80%;
text-align:center;
position:relative;

}
}.ja-JP{
.u_c_CZLO65.normal{
position:fixed;
width:100%;
height:100%;
display:flex;
flex-direction:column;
align-items:center;
justify-content:center;
z-index:10;
left:0;
top:0;

}
}.ja-JP{
.u_c_HRX266.normal{
position:absolute;
width:100%;
height:100%;
top:0;
left:0;
background-color:rgba(0,0,0,.6);

}
}.ja-JP{
.u_c_GZKX67.normal{
font-size:0.33rem;
color:#ffffff;
margin-top:0.40rem;
line-height:0.40rem;
text-align:center;
position:relative;
background-color:#40403f;
border-radius:0.13rem;
padding-top:0.20rem;
padding-bottom:0.20rem;
padding-right:0.33rem;
padding-left:0.33rem;

}
}
</style>
